module.exports = "<div>\r\n  {{ (currentValue != null ? currentValue === true ? 'active' : 'inactive' : 'all') | translate }}\r\n</div>\r\n"